module.exports = function() {
  return new Worker(__webpack_public_path__ + "6b80e943f314ae4fbcfa.worker.js");
};